import React, {useState, useEffect, useRef} from 'react';
import Message  from './Message';
import { addMessage, deleteMessage, localLogout, blockUser, unBlockUser, clearRoom } from '../../actions/ChatRoom'
import { useDispatch } from 'react-redux';


const Chat = ({room, auth, messages, isAdmin, blocked} ) => {
    
    const dispatch = useDispatch();
    const textAreaRef = useRef();
    const chatWrapRef = useRef();
    
    const [msg, setMsg] = useState('');

    const handleDelete = (mid) => {
        dispatch(deleteMessage(room,mid))
    }

    const newMessage = () => {
        dispatch(addMessage(room,auth,msg))
        setMsg('');
    }

    const handleKeyPress = (e) => {
        if(e.key !== 'Enter') return;
        newMessage();
    }

    const handleLogOut = (e) => {
        dispatch(localLogout())
    }

    const handleSend = (e) => {
        e.preventDefault();
        newMessage();
    }

    const handleBlockUser = (ip) => {
        dispatch(blockUser(room,ip));
    }
    const handleUnblockUser = (ip) => {
        dispatch(unBlockUser(room,ip));
    }

    const handleClearRoom = (e) => {
        e.preventDefault();
        dispatch(clearRoom(room));
    }

    const scrollToBottom = () => { 

        const element = chatWrapRef.current;
        element.scrollTop = element.scrollHeight;

    }

    let blockFromPosting = false;

    useEffect(() => {
        scrollToBottom();
    },[messages])

    if(blocked){
        Object.keys(blocked).map(key => {
            if(!blocked[key]) return;
            if(blocked[key].ip === auth.ip){
                blockFromPosting = true;
                return key;
            } else {
                return false;
            }
        });
    }
    
    return (
        <div className="groupchat-chat">
            <div className="chats"ref={chatWrapRef}>
                <div className="chats-wrap">
                    {messages && Object.keys(messages).map(key => {
                        return (
                            <Message 
                                isAdmin={isAdmin} 
                                id={key} 
                                key={key} 
                                message={messages[key]} 
                                auth={auth} 
                                onDelete={handleDelete}
                                onBlock={handleBlockUser}
                                onUnblock={handleUnblockUser}
                                blocked={blocked}
                                />
                        )
                    })}
                </div>
            </div>
            {!blockFromPosting && (
                <div className="chat-control" >
                    <div className="form-field -field-with-button">
                        <label htmlFor="msg">Message: </label>
                        <textarea ref={textAreaRef} id="msg" placeholder="Enter a message" className="form-control" name="msg" onChange={(e) => setMsg(e.target.value)} value={msg} onKeyUp={handleKeyPress}></textarea>
                    </div>
                    <div className="chat-control-bar">
                        <a href="#" onClick={handleLogOut}>Log Out</a>
                        {isAdmin && (<a href="#" onClick={handleClearRoom}>Clear All Messages</a>)}
                        <a href="#" onClick={handleSend}><span className="icon icon-paper-plane"></span></a>
                    </div>
                </div>
            )}

            {blockFromPosting && (
                <div className="user-blocked">You have been blocked by an admin</div>
            )}
            
        </div>
    ); 
}

export default Chat;
